module.exports = __webpack_public_path__ + "img/0_iconPlay.712de6b5.svg";